export var FIELD_NAMES = Object.freeze({
    BIRTHDAY: 'birthday',
    DATE: 'date',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PHONE: 'phone',
    OLD_PASSWORD: 'oldPassword',
    NEW_PASSWORD: 'newPassword',
    CONFIRM_PASSWORD: 'confirmPassword'
});
